import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InvestigationDashboardRepository } from '../../../infrastructure/repositories/investigation-dashboard.repository';
import { GetDashboardInvestigationsQuery } from './get-dashboard-investigations.query';
import { GetDashboardInvestigationsResult } from './get-dashboard-investigations.result';

@Injectable({ providedIn: 'root' })
export class GetDashboardInvestigationsUseCase {
  private readonly _repository = inject(InvestigationDashboardRepository);

  public execute(query: GetDashboardInvestigationsQuery): Observable<GetDashboardInvestigationsResult> {
    let params = new HttpParams()
      .set('Skip', query.skip.toString())
      .set('Take', query.take.toString());

    if (query.sort) {
      params = params.set('Sort', query.sort);
    }
    if (query.filter) {
      params = params.set('Filter', query.filter);
    }
    if (query.search && query.search.trim()) {
      params = params.set('search', query.search.trim());
    }
    if (query.scopeTimeframe) {
      params = params.set('scopeTimeframe', 'true');
    }

    return this._repository.getDashboardInvestigations(params);
  }
}
